import validation from '../../../../validation/index.js'

const bodyRules = { stripeCustomerId: validation.rules.string().required().label('Stripe Customer Id') }

// eslint-disable-next-line import/prefer-default-export
export const body = {
  rules: bodyRules,
  schema: validation.schema(bodyRules),
}
